import { render, staticRenderFns } from "./MarketResults.vue?vue&type=template&id=2547217d&scoped=true&"
import script from "./MarketResults.vue?vue&type=script&lang=js&"
export * from "./MarketResults.vue?vue&type=script&lang=js&"
import style0 from "./MarketResults.vue?vue&type=style&index=0&id=2547217d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2547217d",
  null
  
)

export default component.exports